import { useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtErr } from "../api";
import BrandMark from "../components/BrandMark";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50" data-testid="forgot-password-page">
      <div className="w-full max-w-sm">
        <div className="mb-8"><BrandMark size={44} dark /></div>
        <h2 className="font-heading text-2xl font-bold text-[#002B5D]">Reset password</h2>
        {done ? (
          <div data-testid="forgot-password-done" className="mt-6 text-sm bg-green-50 border border-green-200 text-green-800 rounded-md px-4 py-3">
            If that email is registered, a reset link has been sent.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-5" data-testid="forgot-password-form">
            <div>
              <label className="sk-label" htmlFor="fp-email">Email</label>
              <input id="fp-email" data-testid="forgot-password-email-input" type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)} className="sk-input" />
            </div>
            {error && <div data-testid="forgot-password-error" className="text-sm text-rose-600">{error}</div>}
            <button data-testid="forgot-password-submit" type="submit" disabled={busy}
              className="w-full h-11 rounded-md font-heading font-bold text-white disabled:opacity-60" style={{ backgroundColor: "#EB1C27" }}>
              {busy ? "Sending..." : "Send Reset Link"}
            </button>
          </form>
        )}
        <div className="mt-6 text-center">
          <Link to="/login" data-testid="back-to-login-link" className="text-sm text-[#002B5D] hover:underline">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
